import React from "react";
import "../../css/insightsView.css";
import "../../css/insightsOneView.css";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import { insightsConstants } from "../../constant/insights_constants";
import { DropdownButton, MenuItem } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import $ from "jquery";
import MediaQuery from "react-responsive";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";
import ReactPlayer from "react-player";
import emailForwardIcon from "../../images/icons/send-mail-icon.jpg";
import MailForwardForm from "../../components/MailForwardForm";

const icon1 = "https://winpeforum.com/assets/elements/KhyatiParekh.jpeg";

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
      style={{ margin: "0% auto 0px" }}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div className="item_des">{activeItem.post}</div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};
TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SuhelaKhan extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      activeItem: {},
      isShow: false,
      activeKeyword: "",
      isSearching: false,
      lastCounter: 3,
      activeTitle: "SORT BY",
      activeSortBy: "default",
      showMailShareForm: false,
    };
    this.betterContent = insightsConstants;
     
    this.Speaker = [
      {
        desc: `<div> 
        </div>`,
        name: "Khyati Parekh",
        post: "General Counsel, Edelweiss Alternatives",
        imgUrl: icon1,
        head: "Does it ‘look difficult’ or should I just say ‘no’?",
      },
    ];
  }
  componentDidMount() {
    // function sticky_relocate () {
    // 	var window_top = $(window).scrollTop()
    // 	var div_top = $("#sticky-anchor").offset().top
    // 	if (window_top > div_top) {
    // 		$("#sticky").addClass("stick")
    // 	} else {
    // 		$("#sticky").removeClass("stick")
    // 	}
    // }
    // $(function () {
    // 	$(window).scroll(sticky_relocate)
    // 	sticky_relocate()
    // })
  }

  toggleMailShareForm = () => {
    this.setState({ showMailShareForm: !this.state.showMailShareForm });
  };

  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  handleMenu = (item) => {
    this.setState({
      activeTitle: item.title,
    });

    let leftlist = [...insightsConstants];
    this.betterContent = [];
    if (item.title === "SORT BY") {
      []
        .concat(leftlist)
        // .filter((a) => a.r_type === "Appetizer")
        .forEach((item, i) => this.betterContent.push(item));
    } else if (item.title === "ALL") {
      []
        .concat(leftlist)
        // .filter((a) => a.r_type === "Appetizer")
        .forEach((item, i) => this.betterContent.push(item));
    } else {
      []
        .concat(leftlist)
        .filter((insight) => {
          console.log(insight);
          // a.typee.indexOf(item.title) >= 0}
          let flag = false;
          for (let i = 0; i < insight.itype.length; i++) {
            if (item.title === insight.itype[i]) {
              flag = true;
            }
          }
          return flag;
        })
        .forEach((item, i) => this.betterContent.push(item));
    }
    this.setState({
      activeSortBy: item.title,
    });
    setTimeout(() => {
      this.setState({
        isSearching: false,
      });
    }, 1000);
  };
  handleSearch = (e) => {
    let str = e.target.value.length ? e.target.value.toLowerCase().trim() : "";
    this.setState({
      isSearching: true,
      activeKeyword: str,
    });
    let leftlist = [...insightsConstants];
    this.betterContent = [];
    leftlist.forEach((item) => {
      if (
        item.skey
          .toLowerCase()
          .trim()
          .search(str) > -1
      ) {
        this.betterContent.push(item);
      }
    });
    setTimeout(() => {
      this.setState({
        isSearching: false,
      });
    }, 1000);
  };
  render() {
     

    const {
      defaultStyle,
      isSearching,
      isShow,
      activeTitle,
      activeSortBy,
    } = this.state;
    const { location } = this.props;
    return (
      <div>
         
        <ContentPage>
        <Meta
          title="Does it ‘look difficult’ or should I just say ‘no’? "
          image={"https://winpeforum.com/assets/elements/WinPE_Home_Page_link_image1.jpg"}
          description="As I put one foot in front of the other, trading in the instructor’s jump-squat-bend-twist- circus for my own ‘Itni muddat baad mile ho’ on Spotify on my noise cancelling earphones, I drowned out the cacophony and found a moment of peace in this country that is never quiet!"
          location={location}
        />
          <div className="section__content">
            <div className="insights_wrapper">
              <div className="insights_section">
                
                <div className="insights_content">
                  <div className="drop_src_box">
                   
                  
                  
                  </div>
                  <div className="insights_mid_section">
                    <div className="row">
                      
                     
                      <div className="col-lg-12 col-md-12">
                        <ScrollAnimation
                          delay={0}
                          duration={2}
                          animateIn="slideInRight"
                          offset={600}
                        >
                          <div className="insights_right_text">
                            <div className="insights_blog_page">
                            <br/><br/><br/><br/>
                              <div className="insights_blog_text">
                                {this.Speaker.map((item, i) => {
                                  return (
                                    <div className="row">
                                      <ScrollAnimation
                                        delay={0}
                                        duration={1}
                                        animateIn="zoomIn"
                                        offset={100}
                                      >
                                        <div className="col-md-3 col-sm-6">
                                          <div
                                            className="right_img_section"
                                             
                                          >
                                            <img
                                              src={item.imgUrl} style={{width:'100%'}}
                                              alt="Suhela khan"
                                              className="img-responsive"
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-9 col-sm-6">
                                          <div className="right_name_section">
                                            <div className="r_head">
                                              {item.head}
                                            </div>
                                            <div className="r_name">
                                              {item.name}
                                            </div>
                                            <div className="r_post">
                                           General Counsel,
Edelweiss Alternatives </div>
                                            <div className="r_block">
                                              <span>POEM</span> &#8226; 6
                                              mins read
                                            </div>
                                          </div>
                                          <div className="share_section_one">
                                            <div className="headsocialLink">
                                           
                                             
                                              <span className="hicon">
                                                <a
                                                  style={{
                                                    display: "block !important",
                                                  }}
                                                  href={`https://www.linkedin.com/in/khyati-parekh-0808a87/?originalSubdomain=in`}
                                                  target="_blank"
                                                  className=""
                                                >
                                                  <img
                                                    src="https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </span>
                                              
                                            </div>
                                          </div>
                                        </div>
                                      </ScrollAnimation>
                                    </div>
                                  );
                                })}
                              </div>
                              <div className="insights_blog_text_btm">
                                <div className="text_section">
                                  <div className="into_text" style={{fontStyle:'normal'}}>
                                    
              <div className=" " style={{textAlign:'left'}}>
              I decided to walk. My best walks have been ones when I skedaddle from the workout studio and decide to enjoy the breeze. Where I take a walk, and tell the studio to take one too!
<br/><br/>
 

As I put one foot in front of the other, trading in the instructor’s jump-squat-bend-twist- circus for my own <i>‘Itni muddat baad mile ho’</i> on Spotify on my noise cancelling earphones, I drowned out the cacophony and found a moment of peace in this country that is never quiet!
<br/><br/>
 

Ohh, the sweet permission to skip an early class on a Tuesday morning.<br/>

Or a long review on a Thursday evening. <br/>

Or a boring social do on a Sunday. <br/>

An outing you were dreading for 15 days in a row now. <br/>

Counting down as your heart sank a centimetre every day. <br/>

Fantasizing, imagining and hoping for all kinds of dreadful things to happen, just so you can SKIP!<br/>

<br/><br/>

How much weight actually lifts, as one skips!<br/>

Skip is such an onomatopoeic word, come to think! 😊<br/>

<br/><br/>

And the grand permission - to do.<br/>

To go.<br/>

To come.<br/>

To get it done. <br/>

To close a deal.<br/>

To call the shots. <br/>

To own a piece of work.<br/>

And may I say, to even run your kitchen.<br/>

To come up with unorthodox solutions like hiring six part timers instead of one full timer who will hold you ransom (because you dread the hassle & the housework that would bring!).<br/>

Ohh, the permission to run one’s life!<br/>

<br/>

And the ludicrousness of waiting for imaginary permissions.<br/>

Like the one to ‘just be’, instead of ‘to do’.<br/>

<br/>

As I walked, I also saw again, a light I’ve seen many times before.<br/>

That this ridiculous spandex I’m wearing, I’m allowed to take off.<br/>

This circus crowd claps a bit more for the mermaid that sings, but that is also her curse.<br/>

While the clowns drop their colourful pants and goof around, only some of them are not putting on an act.<br/>

The kids think the calisthenics athletes are magicians. <br/>

The circus will come and go, I can watch or join at will or at ease.<br/>

There isn’t a last or only show. <br/>

I can choose to also change auditoriums or genres. <br/>

As I have, for lifetimes now.<br/>

And each time, I see it, I forget as quickly.<br/>

<br/>

Oh, great Magician in the Sky, how sweet are your games?<br/>

<br/>

<i>Baharon ko chaman, yaad aa gaya hai…</i>. Spotify knows my obsession with Ghulam Ali.<br/><br/>

 

Permission to know and to remember,<br/>

The gentle breath of the earth, the trees in Kabini, the glorious rainforests, of the sun in Bali and the ocean in Kotakinabalu and the deeply magical valleys of Cappadocia.<br/>

Of travel, which is to hack to see better and more clearly with the heart.<br/><br/>

 

The phone rings.  “Ma, how long before you’re home? We’re waiting for breakfast!”<br/>

“Another hour, beta. You guys manage.” Not go-ahead, manage.<br/>

<br/>

Today I am giving myself the space to breathe and someday, I will also try “that word that cannot be said”, whose cousin I use so often when I say, ‘it looks difficult’.<br/><br/>

 

<i>Dil mein ek leher sii uthi hai abhi…</i>.<br/><br/>

 

How exhilrating might it be to just say – “no”, without launching into long explanations and mummifying it in layers of polite-ism.

Someday I will also give myself the permission to exit some family whatsapp groups.<br/><br/>

 

Realizing that these are green slips (why is ‘green slip’ not a dictionary term yet?), I myself can and need to give myself.<br/>

To go first, while the world is hell bent on making me play second.<br/>

And to question my own deep training that thinks it is fine.<br/>

To call out the biases conscious & ‘un’.<br/>

To start occupying space, instead of feeling like I’m just holding it, or worse, intruding.<br/>

To own my voice, in the unique perspective it brings to the world and the workplace.<br/>

To be ok to ‘not have it together’. <br/>

To allow imperfection <br/>

And holding my heart, for however long it needs to be held. <br/>

<br/><br/>

Like the quality of mercy, permission is also twice blessed!
<br/><br/>
 

<i>Chupke chupke, raat din… aasoon bahana yaad hai…</i>.
<br/><br/>
 

 

 


[This essay was written in the Ochre Sky Memoir Writing Workshop organized by Natasha Badhwar and Raju Tai]

              </div>






                                  </div>
                                 
                                 
                                  <div className="r_text_Q"></div>
                                  <div className="r_text_Q"></div>
                                  {/* <div className="r_text">
                                    <div
                                      className="para"
                                      style={{ padding: "20px 0px 0px 0px" }}
                                    >
                                      <i>Interviewed by Sreeja Vasantham</i>
                                    </div>
                                  </div> */}
                                </div>
                             
                              </div>
                      
                            </div>
                          </div>
                        </ScrollAnimation>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <TeamModal
                show={isShow}
                onHide={this.togglePopUp}
                activeItem={this.state.activeItem}
              />
            </div>
          </div>
        </ContentPage>
      </div>
    );
  }
}
SuhelaKhan.propTypes = {
  location: PropTypes.object,
};

export default SuhelaKhan;



// WEBPACK FOOTER //
// ./src/pages/Does-it-look-difficult-or-should-I-just-say-no/index.js